import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/Landing';
import { SignUpPage } from './pages/SignUp';
import { MagicLinkSentPage } from './pages/MagicLinkSent';
import { AuthCallbackPage } from './pages/AuthCallback';
import { OnboardingSitePage } from './pages/OnboardingSite';
import { OnboardingBrandingPage } from './pages/OnboardingBranding';
import { InstallPage } from './pages/Install';
import { DashboardPage } from './pages/Dashboard';
import { PricingPage } from './pages/Pricing';
import { CheckoutPage, CheckoutSuccessPage } from './pages/Checkout';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/signup/sent" element={<MagicLinkSentPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/onboarding/site" element={<OnboardingSitePage />} />
      <Route path="/onboarding/branding" element={<OnboardingBrandingPage />} />
      <Route path="/install" element={<InstallPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
